// extracted by css-extract-rspack-plugin
export default {"diamond":"tw_kuYVQ2bI1L4ox","outline":"nJxICkSU4akPsy5r","fill":"DEz6KhtQpfsZ8OYI"};